<template>
  <div>
    <div class="row mr-1 mr-md-0">
      <div class="col-12">
        <button class="close" @click="close()">
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </div>
    <div class="row p-md-1 ml-2 mb-4">
      <div class="col-12">
        Enterprise Search is a collaboration between the Engineer’s Home Page team and DES. Got feedback or have a question? Tell us on the
        <a
          target="_blank"
          href="https://autodesk.slack.com/sso/saml/start?redir=/app_redirect?channel=adsk-search"
        >#adsk-search</a> channel in Slack.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style scoped>
</style>
